import { Schemas } from 'src/openapi/generated/types';
import { ReservationFlowInvalidRequestError } from 'src/interfaces/reservation_flow';

import { filterReservationFlowInvalidRequestDetails } from '../filter-reservation-flow-invalid-request-details';

export const getInvalidPaymentMethodItems: (
  error: ReservationFlowInvalidRequestError,
) => Schemas.ReservationFlowInvalidRequestItem[] = (error) => {
  const { details } = error;

  return filterReservationFlowInvalidRequestDetails(details)
    .map((detail) => {
      return detail.invalid_items.filter(
        (item) => item.type === 'invalid_payment_method',
      );
    })
    .flat() as Schemas.ReservationFlowInvalidRequestItem[];
};
